/**
 * Generate metadata for PSP pages based on storage type
 * @param {string} storageType - The display name of the storage type (e.g., 'RV', 'Car', 'Climate Controlled')
 * @returns {object} Metadata object with title and description
 */

import { capitalizeString } from 'utils/stringUtils';

const metadata = {
	Self: {
		title: 'Storage 101: How to Rent a Storage Unit Step-by-Step | SpareFoot',
		description:
			'New to self storage? Our ultimate Storage 101 guide explains what self-storage is, how storage units work, and when renting one makes sense for you.',
	},
	RV: {
		title: 'Find the Best RV Storage For You | SpareFoot',
		description:
			'Choose from thousands of RV storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	Car: {
		title: 'Find the Best Car Storage For You | SpareFoot',
		description:
			'Choose from thousands of car storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	'Climate Controlled': {
		title: 'Find the Best Climate Controlled Storage For You | SpareFoot',
		description:
			'Find the best climate controlled storage for your needs. Compare prices, view photos, read reviews, and discover facilities nationwide. Reserve today!',
	},
	Boat: {
		title: 'Find the Best Boat Storage For You | SpareFoot',
		description:
			'Choose from thousands of boat storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	Portable: {
		title: 'Find the Best Portable Storage For You | SpareFoot',
		description:
			'Find the best portable storage for your needs. Compare prices, view photos, read reviews, and discover facilities nationwide. Reserve today!',
	},
	Motorcycle: {
		title: 'Find the Best Motorcycle Storage For You | SpareFoot',
		description:
			'Choose from thousands of motorcycle storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	Electricity: {
		title: 'Find the Best Storage With Electricity For You | SpareFoot',
		description:
			'Find the best storage with electricity for your needs. Compare prices, view photos, read reviews, and discover facilities nationwide. Reserve today!',
	},
	Business: {
		title: 'Find the Best Business Storage For You | SpareFoot',
		description:
			'Compare business storage options nationwide. View facility photos, pricing, amenities, and verified reviews. Find and reserve your unit today!',
	},
	Wine: {
		title: 'Find the Best Wine Storage For You | SpareFoot',
		description:
			'Find the best wine storage for your needs. Compare prices, view photos, read reviews, and discover facilities nationwide. Reserve today!',
	},
	ATV: {
		title: 'Find the Best ATV Storage For You | SpareFoot',
		description:
			'Choose from thousands of ATV storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	Bicycle: {
		title: 'Find the Best Bike Storage For You | SpareFoot',
		description:
			'Choose from thousands of bike storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	'Dirt-Bike': {
		title: 'Find the Best Dirt Bike Storage For You | SpareFoot',
		description:
			'Choose from thousands of dirt bike storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	'Golf Cart': {
		title: 'Find the Best Golf Cart Storage For You | SpareFoot',
		description:
			'Choose from thousands of golf cart storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	College: {
		title: 'Find the Best College Storage For You | SpareFoot',
		description:
			'Compare college storage options nationwide. View facility photos, pricing, amenities, and verified reviews. Find and reserve your unit today!',
	},
	Truck: {
		title: 'Find the Best Truck Storage For You | SpareFoot',
		description:
			'Choose from thousands of truck storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	'Jet Ski': {
		title: 'Find the Best Jet Ski Storage For You | SpareFoot',
		description:
			'Choose from thousands of jet ski storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	Kayak: {
		title: 'Find the Best Kayak Storage For You | SpareFoot',
		description:
			'Choose from thousands of kayak storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	CubeSmart: {
		title: 'Find the Best CubeSmart Storage Near You | SpareFoot',
		description:
			'Choose from thousands of CubeSmart storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	Military: {
		title: 'Find the Best Military Storage For You | SpareFoot',
		description:
			'Compare military storage options nationwide. View facility photos, pricing, amenities, and verified reviews. Find and reserve your unit today!',
	},
	'Drive-Up': {
		title: 'Find the Best Drive Up Storage For You | SpareFoot',
		description:
			'Find the best drive up storage for your needs. Compare prices, view photos, read reviews, and discover facilities nationwide. Reserve today!',
	},
	'24-Hour': {
		title: 'Find the Best 24 Hour Storage For You | SpareFoot',
		description:
			'Find the best 24 hour storage for your needs. Compare prices, view photos, read reviews, and discover facilities nationwide. Reserve today!',
	},
	Vehicle: {
		title: 'Find the Best Vehicle Storage For You | SpareFoot',
		description:
			'Choose from thousands of vehicle storage facilities. Compare prices, amenities, and availability. View photos, read reviews, and reserve!',
	},
	Locker: {
		title: 'Locker Storage Unit Size Guide | What Fits in a Locker Storage Unit?',
		description:
			'Learn what fits in a locker storage unit. See dimensions, storage tips, and real-life examples to help you decide on the right size for your needs.',
	},
};

const dynamicMetadataForSgp = (type) => {
	const shouldRemoveStorage =
		type === 'storage-lockers' || type === 'mini-storage';

	const keyword = type.replace(/-/g, ' ');

	const cleanedKeyword = shouldRemoveStorage
		? keyword.replace(/\bstorage\b/i, '').trim()
		: keyword;
	const description =
		'Learn what fits in a ' +
		cleanedKeyword +
		' storage unit. See dimensions, storage tips, and real-life examples to help you decide on the right size for your needs.';

	return {
		title: `${capitalizeString(type)} Storage Unit Size Guide | What Fits in a ${capitalizeString(type)} Unit?`,
		description: description,
	};
};

export const getMetadata = (storageType) => {
	console.log(storageType, 'storageTypestorageType');
	return (
		metadata[storageType] ||
		dynamicMetadataForSgp(storageType) ||
		metadata.Self
	);
};
